/**
 * @author wangyingxu1
 * vue-cli build entry file
 * 教研菜单栏
 * 依赖 element-ui 部分组件（减小包）
 */

import Vue from 'vue';
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup
} from 'element-ui';

Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);

import {
  IteachMenu,
  IteachMenuTab
} from '@/components';

const iteachMenu: any = {
  IteachMenu,
  IteachMenuTab
};

export default iteachMenu;
